(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      /* Cuanto hay que bajar, ADEMáS de pasar la cabecera, antes de que
         empiece a apartarse. Sin este margen la cabecera se mueve mientras
         todavía estás leyendo lo de arriba, que es justo lo que molesta. */
      this.margenOcultar = 240;

      /* Por debajo de esto no se considera que hayas hecho scroll: rueda
         fina, trackpad y el rebote elástico del móvil generan un goteo de
         eventos de 1-2 px en los dos sentidos, y sin el filtro la cabecera
         entra y sale sola mientras lees. */
      this.deltaMinimo = 6;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    /* A partir de qué altura de scroll puede apartarse la cabecera.

       Dawn usa `this.headerBounds.bottom` a pelo, y en esta tienda ESO VALE
       CERO: el IntersectionObserver se resuelve con la cabecera ya fuera de
       vista y devuelve un rectángulo vacío. Con el límite en 0, las tres
       ramas de onScroll comparában contra `undefined`/0 y la cabecera o no
       se movía nunca o se escondía desde el primer píxel. Medido en la
       tienda el 29 ago 2026: `headerBounds` = {top: 0, bottom: 0, height: 0}.

       Por eso hay red de seguridad: si el rectángulo no sirve, se mide la
       cabecera de verdad. */
    limiteCabecera() {
      var fondo = this.headerBounds && this.headerBounds.bottom
        ? this.headerBounds.bottom
        : this.header.offsetHeight;
      return fondo + this.margenOcultar;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      const delta = scrollTop - this.currentScrollTop;

      /* Zona de cortesía: arriba del todo la cabecera se queda quieta y
         entera, sin pegarse ni esconderse. */
      if (scrollTop <= this.limiteCabecera()) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
        this.currentScrollTop = scrollTop;
        return;
      }

      /* Un temblor no es una intención. Ojo: aquí se sale SIN actualizar
         currentScrollTop, a propósito — así los micromovimientos se van
         sumando y un arrastre lento acaba contando igual. */
      if (Math.abs(delta) < this.deltaMinimo) return;

      this.header.classList.add('scrolled-past-header');

      if (delta > 0) {
        if (this.preventHide) {
          this.currentScrollTop = scrollTop;
          return;
        }
        requestAnimationFrame(this.hide.bind(this));
      } else {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      /* Dawn ponía `animate` SOLO al volver, así que la cabecera se iba de
         golpe y volvía deslizando. Ahora la transición cuelga de
         .shopify-section-header-sticky (gallery.css) y va en los dos
         sentidos; la clase se mantiene por si algo de Dawn la mira. */
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
